import { render, staticRenderFns } from "./DocPertes.vue?vue&type=template&id=6c5d2f27&"
import script from "./DocPertes.vue?vue&type=script&lang=js&"
export * from "./DocPertes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports